exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loadingFullPage{width:100%;height:100%;max-height:100vh;position:fixed;background:#fff;overflow:hidden;top:0;left:0;z-index:2001;display:none}.loadingFullPage.active{display:block}.loadingFullPage__image_container{width:200px;height:200px;position:relative;top:calc(50% - 100px);left:calc(50% - 100px)}.loadingFullPage__image_container .imagebox{margin:auto;width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;justify-items:center;place-items:center}.loadingFullPage__image_container .imagebox__text{position:absolute;text-align:center;font-size:10px;bottom:24px;margin:auto;width:100%;color:#f01278}.loadingFullPage img{display:block;margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17bb8484","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/LoadingFullPage.vue
// module id = J3LX
// module chunks = 0